import React from "react";
import "./ToggleSwitch.css";

interface ToggleSwitchProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
  labelOn: string;
  labelOff: string;
}

const ToggleSwitch: React.FC<ToggleSwitchProps> = ({ checked, onChange, labelOn, labelOff }) => {
  return (
    <div className="toggle-switch">
      <input
        type="checkbox"
        id="toggleSwitch"
        checked={checked}
        onChange={(e) => onChange(e.target.checked)}
      />
      <label htmlFor="toggleSwitch">
        <span className="toggle-slider"></span>
      </label>
      <span className="toggle-label">{checked ? labelOn : labelOff}</span>
    </div>
  );
};

export default ToggleSwitch;
